<h2 mat-dialog-title>Controle de Lotes</h2>

<mat-dialog-content>
  <div class="produto-info">
    <span class="produto-nome">{{ nomeProduto }}</span>
    @if (skuProduto) {
      <span class="produto-sku">SKU: {{ skuProduto }}</span>
    }
    <span class="status-badge badge-cinza status-qtd">
      {{ isNarrow ? 'Saldo sist.' : 'Saldo sistema' }}: {{ saldoSistema | number:'1.2-4' }}
      / {{ isNarrow ? 'Contado' : 'Total contado' }}: {{ totalContado | number:'1.2-4' }}
    </span>
  </div>

  @if (isLoading) {
    <div class="loading-row">
      <mat-spinner diameter="28"></mat-spinner>
      <span>Carregando lotes em estoque…</span>
    </div>
  }

  @if (erroCarga) {
    <div class="error-banner">{{ erroCarga }}</div>
  }

  @if (!isReadOnly) {
    <div class="lista-toolbar">
      <span class="lista-titulo">Lotes</span>
      <button mat-stroked-button class="btn-secondary" (click)="adicionarLinha()">
        <mat-icon>add</mat-icon>
        Adicionar lote
      </button>
    </div>
    <p class="hint-text">
      Remover um lote existente registra contagem zero para fins de auditoria.
    </p>
  }

  @if (!isLoading && dataSource.data.length === 0) {
    <div class="empty-contacts">Nenhum lote em estoque nesta localização. Clique em "Adicionar lote" para incluir.</div>
  } @else if (isNarrow) {
    <div class="modal-card-list">
      @for (row of dataSource.data; track row; let i = $index) {
        <div class="modal-card" [class.linha-invalida]="isLinhaInvalida(row)">
          <div class="modal-card__header">
            @if (row.isExistente || isReadOnly) {
              <span class="modal-card__title" [class.removido]="row.isRemovido">
                {{ row.codigoLote }}
                @if (!row.isExistente) {
                  <span class="badge-novo" matTooltip="Lote novo (será criado no processamento)">novo</span>
                }
              </span>
            } @else {
              <mat-form-field appearance="outline" subscriptSizing="dynamic" class="modal-card__header-main">
                <mat-label>Código do Lote</mat-label>
                <input matInput [(ngModel)]="row.codigoLote" placeholder="Ex: LOT-001" />
              </mat-form-field>
            }
            @if (!isReadOnly) {
              @if (row.isRemovido) {
                <button mat-icon-button (click)="desfazerRemocao(i)" matTooltip="Restaurar saldo contado">
                  <mat-icon>undo</mat-icon>
                </button>
              } @else {
                <button mat-icon-button color="warn"
                  [matTooltip]="row.isExistente ? 'Remover (zera saldo contado)' : 'Remover linha'"
                  (click)="removerLote(i)">
                  <mat-icon>delete</mat-icon>
                </button>
              }
            }
          </div>
          <div class="modal-card__body">
            <div class="modal-card__grid">
              @if (row.isExistente || isReadOnly) {
                <div class="modal-card__ro" [class.removido]="row.isRemovido">
                  <small>Fabricação</small>
                  <span>{{ row.dataFabricacao ? (row.dataFabricacao | date:'dd/MM/yyyy') : '—' }}</span>
                </div>
              } @else {
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Fabricação</mat-label>
                  <input
                    matInput
                    [matDatepicker]="pickerFabC"
                    [(ngModel)]="row.dataFabricacao"
                    (input)="onDateInput($event)"
                    (keydown)="onDateKeydown($event)"
                    (blur)="onDataFabricacaoBlur($event, row)"
                    placeholder="DD/MM/AAAA"
                    inputmode="numeric"
                    maxlength="10"
                    [max]="hoje" />
                  <mat-datepicker-toggle matIconSuffix [for]="pickerFabC"></mat-datepicker-toggle>
                  <mat-datepicker #pickerFabC></mat-datepicker>
                </mat-form-field>
              }
              @if (row.isExistente || isReadOnly) {
                <div class="modal-card__ro" [class.removido]="row.isRemovido">
                  <small>Validade</small>
                  <span>{{ row.validadeLote ? (row.validadeLote | date:'dd/MM/yyyy') : '—' }}</span>
                </div>
              } @else {
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Validade</mat-label>
                  <input
                    matInput
                    [matDatepicker]="pickerC"
                    [(ngModel)]="row.validadeLote"
                    (input)="onDateInput($event)"
                    (keydown)="onDateKeydown($event)"
                    (blur)="onDataValidadeBlur($event, row)"
                    placeholder="DD/MM/AAAA"
                    inputmode="numeric"
                    maxlength="10"
                    [min]="row.dataFabricacao" />
                  <mat-datepicker-toggle matIconSuffix [for]="pickerC"></mat-datepicker-toggle>
                  <mat-datepicker #pickerC></mat-datepicker>
                </mat-form-field>
              }
              <div class="modal-card__ro" [class.removido]="row.isRemovido">
                <small>Saldo Sistema</small>
                <span>{{ row.isExistente ? (row.saldoSistema | number:'1.2-4') : '—' }}</span>
              </div>
            </div>
            @if (isReadOnly) {
              <div class="modal-card__ro" [class.removido]="row.isRemovido">
                <small>Saldo Contado</small>
                <span>{{ row.saldoContado | number:'1.2-4' }}</span>
              </div>
            } @else {
              <mat-form-field appearance="outline" subscriptSizing="dynamic">
                <mat-label>Saldo Contado</mat-label>
                <input matInput type="text" inputmode="decimal" [currencyMask]="quantidadeMask" [(ngModel)]="row.saldoContado" placeholder="0,00" />
              </mat-form-field>
            }
          </div>
        </div>
      }
    </div>
  } @else {
    <div class="table-responsive">
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z0 w-100 tabela-edicao modal-tabela-cards">

        <ng-container matColumnDef="codigoLote">
          <th mat-header-cell *matHeaderCellDef>Código do Lote</th>
          <td mat-cell *matCellDef="let row" [class.removido]="row.isRemovido"
              [attr.data-label]="(row.isExistente || isReadOnly) ? 'Código do Lote' : null">
            @if (row.isExistente || isReadOnly) {
              {{ row.codigoLote }}
              @if (!row.isExistente) {
                <span class="badge-novo" matTooltip="Lote novo (será criado no processamento)">novo</span>
              }
            } @else {
              <mat-form-field appearance="outline" class="field-edit" subscriptSizing="dynamic">
                @if (isNarrow) { <mat-label>Código do Lote</mat-label> }
                <input matInput [(ngModel)]="row.codigoLote" placeholder="Ex: LOT-001" />
              </mat-form-field>
              <span class="badge-novo" matTooltip="Lote novo (será criado no processamento)">novo</span>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="dataFabricacao">
          <th mat-header-cell *matHeaderCellDef>Fabricação</th>
          <td mat-cell *matCellDef="let row" [class.removido]="row.isRemovido"
              [attr.data-label]="(row.isExistente || isReadOnly) ? 'Fabricação' : null">
            @if (row.isExistente || isReadOnly) {
              {{ row.dataFabricacao ? (row.dataFabricacao | date:'dd/MM/yyyy') : '—' }}
            } @else {
              <mat-form-field appearance="outline" class="field-edit field-edit-data" subscriptSizing="dynamic">
                @if (isNarrow) { <mat-label>Fabricação</mat-label> }
                <input
                  matInput
                  [matDatepicker]="pickerFab"
                  [(ngModel)]="row.dataFabricacao"
                  (input)="onDateInput($event)"
                  (keydown)="onDateKeydown($event)"
                  (blur)="onDataFabricacaoBlur($event, row)"
                  placeholder="DD/MM/AAAA"
                  inputmode="numeric"
                  maxlength="10"
                  [max]="hoje" />
                <mat-datepicker-toggle matIconSuffix [for]="pickerFab"></mat-datepicker-toggle>
                <mat-datepicker #pickerFab></mat-datepicker>
              </mat-form-field>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="validadeLote">
          <th mat-header-cell *matHeaderCellDef>Validade</th>
          <td mat-cell *matCellDef="let row" [class.removido]="row.isRemovido"
              [attr.data-label]="(row.isExistente || isReadOnly) ? 'Validade' : null">
            @if (row.isExistente || isReadOnly) {
              {{ row.validadeLote ? (row.validadeLote | date:'dd/MM/yyyy') : '—' }}
            } @else {
              <mat-form-field appearance="outline" class="field-edit field-edit-data" subscriptSizing="dynamic">
                @if (isNarrow) { <mat-label>Validade</mat-label> }
                <input
                  matInput
                  [matDatepicker]="picker"
                  [(ngModel)]="row.validadeLote"
                  (input)="onDateInput($event)"
                  (keydown)="onDateKeydown($event)"
                  (blur)="onDataValidadeBlur($event, row)"
                  placeholder="DD/MM/AAAA"
                  inputmode="numeric"
                  maxlength="10"
                  [min]="row.dataFabricacao" />
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="saldoSistema">
          <th mat-header-cell *matHeaderCellDef>Saldo Sistema</th>
          <td mat-cell *matCellDef="let row" [class.removido]="row.isRemovido" [attr.data-label]="'Saldo Sistema'">
            {{ row.isExistente ? (row.saldoSistema | number:'1.2-4') : '—' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="saldoContado">
          <th mat-header-cell *matHeaderCellDef>Saldo Contado</th>
          <td mat-cell *matCellDef="let row" [class.removido]="row.isRemovido"
              [attr.data-label]="isReadOnly ? 'Saldo Contado' : null">
            @if (isReadOnly) {
              {{ row.saldoContado | number:'1.2-4' }}
            } @else {
              <mat-form-field appearance="outline" class="field-edit field-edit-qtd" subscriptSizing="dynamic">
                @if (isNarrow) { <mat-label>Saldo Contado</mat-label> }
                <input matInput type="text" inputmode="decimal" [currencyMask]="quantidadeMask" [(ngModel)]="row.saldoContado" placeholder="0,00" />
              </mat-form-field>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="acoes">
          <th mat-header-cell *matHeaderCellDef class="text-end">Ações</th>
          <td mat-cell *matCellDef="let row; let i = index" class="cell-acoes">
            @if (row.isRemovido) {
              <button mat-button (click)="desfazerRemocao(i)" matTooltip="Restaurar saldo contado">
                <mat-icon>undo</mat-icon>
                Desfazer
              </button>
            } @else {
              <button mat-icon-button color="warn"
                [matTooltip]="row.isExistente ? 'Remover (zera saldo contado)' : 'Remover linha'"
                (click)="removerLote(i)">
                <mat-icon>delete</mat-icon>
              </button>
            }
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" [class.linha-invalida]="isLinhaInvalida(row)"></tr>
      </table>
    </div>
  }

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button class="btn-secondary" (click)="cancelar()">Cancelar</button>
  @if (!isReadOnly) {
    <button mat-flat-button class="btn-primary" (click)="confirmar()" [disabled]="hasLinhaInvalida">Confirmar</button>
  }
</mat-dialog-actions>
